export const companySettingsi18n = {
  companySettingsView: {
    companyCascaderSearchPlaceholder: 'Search company…',
    companyOrCountryCascaderSearchPlaceholder: 'Search company or country…',
    companyOrBusinessUnitCascaderSearchPlaceholder: 'Search company or business unit…',
    countryCascaderSearchPlaceholder: 'Search country…',
    appraisalTab: {
      heading: 'Appraisal',
      infoBox: {
        status: {
          heading: 'Appraisal Status',
          notInvited: 'Not Invited',
          invited: 'Invited',
          waiting: 'Waiting',
          confirmed: 'Confirmed',
          forceConfirmed: 'Forced',
          disputedConfirmed: 'Disputed',
          description:
            "This is the overall status of all the employees' meetings for the current Appraisal season. Only meetings of the type “Appraisal” are counted.",
        },
        skillStatus: 'Skill status sync',
        mandatory: {
          heading: 'Mandatory',
          filterTooltip: 'Filter by mandatory meeting.',
          filterText: 'Filter "Mandatory"',
          employees: 'employees',
          subtitle:
            'The meeting is mandatory if the employee has a Target Bonus for the current year or spent an amount of time in Reply. These are the employees whose Appraisals are currently mandatory.',
        },
        todo: {
          heading: 'To do ({{asYear}})',
          buHeading: 'To do (Current Season)',
          filterTooltip: 'Filter by To do meeting.',
          filterText: 'Filter "To do"',
          subtitle:
            'Every employee must have at least one meeting in their current company. These are the employees whose meetings need to be handled by the end of the current Appraisal Season.',
        },
        selectOptions: {
          appraisal: 'Appraisal',
          appraisalUpdate: 'Appraisal update',
        },
        counters: {
          buHeading: 'Meeting Status (Current Season)',
          heading: 'Meeting Status ({{asYear}})',
        },
      },
      table: {
        emptyTable: 'No employee matches the selected filter criteria',
        todo: {
          done: 'Done',
          notDone: 'To do',
        },
        skillStatus: {
          heading: 'Skill status',
        },
        employee: {
          heading: 'Employee',
        },
        status: {
          heading: 'Status',
          tooltip: {
            notInvited: "{{employeeName}} wasn't invited yet.",
            invited: '{{reviewerName}} invited {{employeeName}} on {{appraisalDate}}.',
            waiting: 'Waiting for {{employeeName}} to confirm. {{meetingWasOn}}',
            confirmed: '{{employeeName}} confirmed the meeting. {{meetingWasOn}}',
            confirmedFeedback: '{{employeeName}} confirmed the meeting but had feedback. {{meetingWasOn}}',
            confirmedDisputed: '{{employeeName}} disputed the meeting. {{meetingWasOn}}',
            confirmedByHr: 'HR spoke with {{employeeName}} and agreed on {{result}} {{meetingWasOn}}',
            confirmedByHrResult: {
              appraisalUpdate: 'having an appraisal update meeting.',
              keepingChanges: 'keeping the changes.',
            },
            meetingWasOn: 'The meeting was on {{appraisalDate}} with {{reviewerName}}.',
          },
        },
        meeting: {
          heading: 'Meeting',
          status: {
            a: 'Appraisal',
            au: 'Appraisal Update',
          },
        },
        confirmation: {
          heading: 'Confirmation',
          reviewedBy: 'Reviewed by',
          discussedWith: 'Discussed with',
        },
        companyConfirmation: {
          heading: 'Company Confirmation',
          reviewedBy: 'Reviewed by',
          discussedWith: 'Discussed with',
        },
        employeeConfirmation: {
          heading: 'Employee Confirmation',
          reviewedBy: 'Reviewed by',
          discussedWith: 'Discussed with',
        },
        bu: {
          heading: 'BU',
        },
        office: {
          heading: 'Office',
          notAvailable: 'N/A',
        },
        type: {
          heading: 'Type',
          skippedSteps: 'Skipped steps:',
          reason: 'Reason:',
        },
        appraisalSeason: {
          heading: 'Season',
        },
        feedback: {
          heading: 'Feedback',
          tooltip: {
            approved: 'Review feedback of approved meeting',
            disputed: 'Review feedback of disputed meeting',
            resolvedApproved: 'View resolved feedback of approved meeting',
            resolvedDisputed: 'View resolved feedback of disputed meeting',
            fallback: 'Feedback',
          },
          modal: {
            heading: {
              review: 'Review feedback',
              resolved: 'View resolved feedback',
              subheading: 'From {{employee}} on {{date}} with {{reviewer}}',
            },
            feedback: {
              approved: '{{employee}} approved the meeting, but had feedback for HR',
              disputed: '{{employee}} disputed the meeting',
              fallback: '{{employee}} had feedback',
            },
            hrComment: {
              heading: 'HR internal notes',
              inputPlaceholder: 'Please leave a comment',
              btnSave: 'Save comment',
              btnTooltip: {
                emptyComment: 'Empty comment',
                commentTooShort: 'Inserted comment is too short',
              },
            },
            result: {
              heading: 'Result',
              edit: {
                description: 'HR spoke with {{employee}} and agreed on',
                option: {
                  keeping: 'Keeping the changes',
                  appraisalUpdateMeeting: 'Having an appraisal update meeting',
                },
              },
              view: {
                description: 'HR spoke with {{employee}} and agreed on ',
                option: {
                  keeping: 'keeping the changes',
                  appraisalUpdateMeeting: 'having an appraisal update meeting',
                },
              },
            },
            btnConclusion: 'Conclusion',
            btnReadAndResolve: 'Read and resolve',
            btnConfirmTooltip: {
              genericMessage: 'All fields must be filled up',
              commentTooShort: 'Inserted comment is too short',
            },
          },
        },
        actions: {
          heading: 'Action',
          conclusionBtnTooltip: 'View conclusion PDF',
          forceConfirmBtnTooltip: 'Confirm Appraisal without consent of employee',
          profileBtnTooltip: 'Profile',
        },
      },
      mandatory: {
        true: 'Mandatory',
        false: 'Not Mandatory',
      },
      type: {
        Normal: 'Normal',
        SkippedSteps: 'Skipped',
        ForcedTargets: 'Forced Targets',
      },
      skippedSteps: {
        Evaluation: 'Evaluation',
        SelfReflection: 'Self-Reflection',
      },
      filter: {
        counters: 'Filtered Employees',
        heading: 'Employees Filters',
        level: 'Employee Level',
        levelPlaceholder: 'Select level',
        mandatoryPlaceholder: 'Select mandatory',
        todoPlaceholder: 'Select to do',
        skillStatusPlaceholder: 'Select skill status',
        bu: 'Business Unit',
        buPlaceholder: 'Select BU',
        office: 'Office',
        officePlaceholder: 'Select office',
        reset: 'Clear filters',
        appraisalSeasons: 'Latest meeting in seasons',
        seasonsPlaceholder: 'Select Appraisal Seasons',
        mandatory: 'Mandatory',
      },
    },
    requestedMeetingsTab: {
      heading: 'Meeting Requests',
      table: {
        requestedOn: 'Requested on',
        type: 'Type',
        employee: 'Employee',
        reviewer: 'Reviewer',
        reason: 'Reason',
        filteredEmpty: 'At the moment there are no {{meetingRequestStatus}} meeting requests.',
        reasonOfRequest: 'Request reason',
        reasonOfRejection: 'Rejection reason',
      },
    },
    reviewerTab: {
      heading: 'Reviewer',
      infoBox: {
        reviewer: {
          heading: 'Reviewer',
        },
        types: {
          heading: 'Reviewer Types',
          internal: 'Internal',
          external: 'External',
        },
        employeesWithMoreReviewers: {
          heading: 'Employees with more than one Reviewer',
          employees: 'employees',
        },
        add: {
          heading: 'Add',
          btnTooltip: 'Add reviewer relation',
        },
      },
      addModal: {
        heading: 'Add reviewer relation for',
        headingNoCompany: 'company',
        inverseRelationshipeExists:
          "The selected employees are already involved in a relationship. {{reviewer}} is currently {{reviewee}}'s reviewer.",
        reviewer: {
          label: 'Reviewer',
          placeholder: 'Select Reviewer',
          notFoundContent: 'No reviewers to select.',
          notFoundSearchSelectContent: 'Please type in some longer name or name matching failed...',
        },
        employee: {
          label: 'Employee',
          placeholder: 'Select Employee',
          notFoundContent: 'No employees to select.',
        },
        saveBtn: {
          tooltipReviewerAndEmployeeMissing: 'Please select a reviewer and employee.',
          tooltipEmployeeMissing: 'Please select an employee.',
          tooltipReviewerMissing: 'Please select a reviewer.',
          tooltipAlreadyExistsRelation: 'This reviewer relation already exists',
          tooltipSameEmployee: 'Reviewer and employee cannot be the same person.',
        },
        notifications: {
          success: {
            title: 'Success',
            description: 'Reviewer-Reviewee relation successfully created.',
          },
          error: {
            title: 'Error while creating Reviewer-Reviewee relation',
            description: 'An error occurred while creating the relation. Please, try again.',
          },
        },
      },
      deleteModal: {
        title: 'Delete Reviewer Relation',
        description1: 'Are you sure you want to remove this reviewer assignment?',
        description2: 'This action cannot be undone.',
        error: 'An error occurred while deleting this reviewer relation.',
        notifications: {
          delete: {
            success: {
              title: 'Relation deleted',
              description: 'Reviewer-Reviewee Relation successfully deleted.',
            },
          },
        },
      },
      table: {
        reviewer: {
          heading: 'Reviewer',
        },
        employee: {
          heading: 'Employee',
        },
        fromDate: {
          heading: 'Since',
        },
        type: {
          heading: 'Reviewer Type',
          INTERNAL: 'Internal',
          EXTERNAL: 'External',
        },
        actions: {
          heading: 'Actions',
          deleteBtnTooltip: 'Delete reviewer relation',
          infoBtnTooltip: 'The reviewer is external. You have no permission to delete this relation. Please ask HR to remove it.',
        },
        empty: {
          heading: 'Currently no reviewers are assigned for this company.',
          buHeading: 'Currently no reviewers are assigned for this business unit.',
        },
      },
    },
    otherMeetingsTab: {
      heading: 'Other Meetings',
    },
    employeesTab: {
      heading: 'Employees',
    },
    rankingTab: {
      rankingModal: {
        enableRanking: 'Enable Ranking',
        enableRankingDescription: 'Do you want to enable the ranking for this company?',
        disableRanking: 'Disable Ranking',
        disableRankingDescription: 'Do you want to disable the ranking for this company?',
        notifications: {
          enable: {
            success: {
              title: 'Success',
              description: 'Ranking successfully enabled.',
            },
          },
          disable: {
            success: {
              title: 'Success',
              description: 'Ranking successfully disabled.',
            },
          },
        },
      },
      rankingSettingsModal: {
        openRankingHeading: 'Manage settings and open',
        editRankingHeading: 'Edit settings',
        percentageOfLow: 'Min percentage of Low',
        percentageOfTop: 'Max percentage of Top',
        contractChanges: 'Employment changes',
        numberOfEmployees: 'Number of employees ',
        contractChangesDescription: 'Allow employees with Low tag to have employment changes',
        contractChangesDisabledDueToEntryLevelLow:
          'This setting cannot be changed while at least one employee with future employment changes has a Low tag.',
        reason: 'Reason',
        reasonPlaceholder: 'Please describe your reason',
        disclaimer1: 'You are opening the Performance Assignment and Ranking for the year {{year}}.',
        disclaimer2: 'Once confirmed, you will not be able to edit the {{year}} ranking.',
        disclaimer3: 'Do you want to proceed?',
        disclaimer4: 'You are changing requests for the Performance Assignment and Ranking for the year {{year}}.',
        openRanking: 'Open Ranking',
        saveChanges: 'Save Changes',
        rankingReportGenerationInProgressOrFailed:
          'It is not possible to open the season because the generation of the ranking report is in progress or failed.',
        rankingConfirmationError: 'An error occurred while confirming your ranking.',
        notifications: {
          success: {
            title: 'Success',
            description: 'Ranking successfully {{operation}}.',
          },
        },
      },
      rankingDisclaimer: {
        openedRankingMessageForHr: "The {{year}} ranking hasn't been confirmed yet.",
        openedRankingDescriptionForHr: 'After confirming the ranking, the company will be able to schedule {{year}} appraisals.',
        openedRankingMessage: 'You did not complete the performance assignment and confirm ranking',
        openedRankingMessageForBusinessPartner: `Performance assignment and confirm ranking haven't been completed by the Company Manager, yet.`,
        openedRankingDescription: 'Please note that upon starting the ranking, employees are sorted by decreasing Evaluation.',
        confirmedRankingMessage: 'Ranking and Tags assignment has been completed',
        confirmedRankingDescription: 'The appraisal process is now allowed in your company.',
      },
      cultivatingTalentsDisabled: 'Cultivating talents is disabled for this company and country',
      seasonNotOpenYet: 'Ranking is enabled but no season has opened yet',
      enableRanking: 'Enable ranking',
      otherYears: 'Other years',
      heading: 'Cultivating Talents',
      modalRemoveLow: {
        title: 'Remove Low tag',
        subtitle: 'Of {{employee}}',
        checkboxLabel: 'Yes, I want to remove the low tag of {{employee}}.',
        checkboxFieldName: 'checkbox',
        textAreaLabel: 'Reason',
        textAreaPlaceholder: 'Please add a reason',
        textAreaFieldName: 'reason',
        textAreaFieldLength: 'Inserted text is too short',
        confirmButtonTooltip: {
          genericMessage: 'All fields must be filled up',
          reasonTooShort: 'Inserted reason is too short',
        },
        notifications: {
          success: {
            title: 'Completed',
            description: 'Low tag removed.',
          },
        },
        confirmError: 'Something went wrong while removing the LOW tag.',
      },
      settings: {
        rankingStatus: 'Ranking Status',
        status: 'Status',
        confirmationDate: 'Confirmed on {{confirmationDate}} by {{employee}}',
        statusReady: 'Ready to open',
        statusOpened: 'In progress',
        statusClosed: 'Closed',
        statusConfirmed: 'Confirmed',
        edit: 'Edit',
        open: 'Open',
        editRanking: 'Edit Ranking',
        guidelines: {
          button: 'Guidelines',
          heading: 'Ranking Guidelines',
          d1: 'The ranking allows you to identify and reward high-performing employees, while also identifying and addressing further development needs.',
          d2: 'Once the ranking feature is active, its confirmation becomes mandatory in order to schedule the appraisal meetings. You can have cases of people who are not assessable in the company for several reasons: newly hired, resigning, on maternity leave, etc. These cases can be excluded by specifying the reason.',
          d3: 'Top and Low tags must be managed via UI only and follow your company percentages % guidelines.',
          d4: 'All other steps to perform the employee ranking can be carried out in two ways: directly on this page and/or using the Excel template.',
          excel: 'Rank by using the <0>Excel Template</0>:',
          excel1: 'Click "<0>Export</0>" to download the Excel template;',
          excel2:
            'Work on the excel file editing the "<0>Current Ranking</0>" column. If there are some employees that are not assessable, remember to edit also the column "<0>Assessable</0>" changing it in "<0>0</0>";',
          excel3: 'Come back in the <0>Cultivating Talents Section</0>, click on "<0>Edit Ranking</0>" and then on "<0>Import</0>";',
          excel4: 'Select the file you want to import and "<0>Apply Changes</0>";',
          excel5: 'Check the ranking and if there are no further adjustment you want to process, confirm it.',
          evaluation: 'Rank by using the "<0>Rank By Evaluation</0>" function:',
          evaluation1: 'Click on "<0>Edit Ranking</0>" and you will see the "<0>Rank by Evaluation</0>" button;',
          evaluation2:
            'Click on "<0>Rank by Evaluation</0>": the function allows you to order based on the last evaluations (preloaded values from the evaluation grid function, if any, or the last confirmed ones in the appraisals);',
          evaluation3:
            'Check the ranking and if there are no further adjustment you want to process (remember to set the non-assessable employees, if any, via "<0>non-assessable</0>" toggle) and confirm it.',
        },
        rankingDisable: 'Enable cultivating talents',
        allowContractChanges: 'Allow employment changes for low',
        lowPercentage: 'Min % of low',
        topPercentage: 'Max % of top',
        topPerformance: 'Top performance assignment',
        inProgress: 'In Progress',
        start: 'Start',
        topPercentageTooltip: 'Top percentage must be higher than zero to start the top ranking process',
      },
      modal: {
        header: 'Top performance assignment opening',
        description: "Once you open the new season of TOP tag assignment, you can't undo it anymore.",
        confirmation: 'Do you really want to proceed?',
        error: 'Error enabling TOP tag process',
      },
    },
    rankingPhaseTwoTab: {
      heading: 'Cultivating Talents',
      hrSettingsHeading: 'Ranking',
    },
    pyramidsTab: {
      heading: 'Pyramids',
      row: {
        chartAria: 'Reference pyramid chart showing recommended range per column',
        empty: {
          heading: 'This company has no {{type}} Reference Pyramid yet.',
          info: 'Keep in mind, if this company is allowed to have a reference pyramid for {{type}}.',
          button: 'Add reference for {{type}}',
        },
      },
      editModal: {
        heading: 'Edit {{type}} Pyramid Reference',
        headingCreateNew: 'Add new {{type}} pyramid reference',
        subheading: 'for {{companyName}}',
        predefinedScenario: {
          placeholder: 'You can select a predefined scenario',
          empty: 'No predefined scenarios for your country available.',
        },
        notifications: {
          create: {
            success: {
              title: 'Success',
              description: '{{pyramidType}} Reference Pyramid successfully created.',
            },
          },
          update: {
            success: {
              title: 'Success',
              description: '{{pyramidType}} Reference Pyramid successfully updated.',
            },
          },
          delete: {
            success: {
              title: 'Success',
              description: '{{pyramidType}} Reference Pyramid successfully deleted.',
            },
          },
        },
      },
    },
    targetTemplatesTab: {
      heading: 'Target Templates',
      infoBox: {
        heading: 'Target Templates',
        add: {
          createNew: 'Create new',
          createNewTooltip: 'Create new',
        },
      },
      table: {
        targets: 'Targets',
        tasks: 'Tasks',
        creator: 'Creator',
        lastEdited: 'Last edited on',
        empty: {
          heading: 'This company has no target template yet',
          info: 'Please start adding some',
          button: 'Add target template',
        },
        actions: {
          heading: 'Actions',
          editTooltip: 'Edit',
          duplicateTooltip: 'Duplicate',
          deleteTooltip: 'Delete',
        },
        notifications: {
          delete: {
            title: 'Success',
            description: 'Target template successfully deleted.',
          },
          duplicate: {
            error: {
              title: 'Error while duplicating Target Template',
              description: 'An error occurred while duplicating the Target Template. Please, try again.',
            },
          },
        },
      },
    },
    targetReportsTab: {
      heading: 'Targets Reports',
      header: {
        heading: 'Targets Reports',
        infoText: "Here you can generate and download a report for the employees' targets in this Company.",
        generateReport: 'Generate Report',
        generatingReport: 'Generating Report',
        generatingReportTooltip: 'A report is already being generated for {{company}} - {{country}}. Please wait.',
        generationDisabledTooltip: 'Report generation was temporarily suspended due to a persistent error',
        notifications: {
          error: {
            title: 'Error while generating Target Report',
            description: 'An error occurred while generating the Target Report. Please, try again.',
            generationDisabledText: 'Report generation was temporarily suspended due to a persistent error.',
          },
          success: {
            title: 'Success',
            description: 'Target Report generation successfully started.',
          },
          warning: {
            title: 'Warning',
            description: 'A Target Report is already being generated. Please wait.',
          },
        },
      },
      table: {
        empty: 'This company has no target report yet',
        filename: 'File name',
        creator: 'Creator',
        date: 'Date',
        size: 'Size',
        actions: 'Actions',
        downloadTooltip: 'Download report',
        processingTooltip: 'The report is being processed',
        errorTooltip: `There was an error and the report couldn't be generated`,
      },
    },
    appraisalSeasonTab: {
      heading: 'Appraisal Season',
      infoBox: {
        heading: 'Appraisal Season',
        defaultStartingDateLabel: 'Country default starting date',
        currentStartingDateLabel: 'Current starting date ({{year}})',
        nextSeasonStartingDateLabel: 'Starting date for next season ({{year}})',
        modal: {
          heading: 'Edit starting date',
          subHeading: 'Here you can change the appraisal season starting month for the current company.',
        },
        errorMessage: 'An error occurred while updating the starting date of next Appraisal Season',
        notifications: {
          success: {
            title: 'Success',
            description: 'Next Appraisal Season starting date successfully updated.',
          },
        },
      },
    },
    feedbackTab: {
      heading: 'Feedback',
      infoBox: {
        heading: 'Filters',
        meetingResolution: 'Meeting Resolution',
        meetingStatus: 'Meeting Status',
        companyFromDate: 'Company From Date',
        companyToDate: 'Company To Date',
        employeeFromDate: 'Employee From Date',
        employeeToDate: 'Employee To Date',
        counters: 'Feedbacks to resolve',
        pendingFeedback: 'To Resolve',
        resolved: 'Read',
        disputed: 'Disputed',
      },
      table: {
        toResolve: 'To Resolve',
        read: 'Read',
        heading: {
          employee: 'Employee',
          company: 'Company',
          appraisalSeason: 'Season',
          status: 'Status',
          feedback: 'Feedback',
          resolution: 'Resolution',
          actions: 'Actions',
        },
        emptyTable: 'No meeting matches the selected filter criteria',
        notifications: {
          readAndConfirm: {
            success: {
              title: 'Success',
              description: 'Meeting successfully read and confirmed.',
            },
          },
          resolve: {
            success: {
              title: 'Success',
              description: 'Meeting successfully resolved with: {{meetingResolutionType}}.',
            },
          },
        },
      },
    },
    hrBusinessPartnersTab: {
      heading: 'HR Business Partners',
      table: {
        employee: 'Employee',
        companyName: 'Company',
        fromDate: 'From Date',
        actions: 'Actions',
        delete: 'Delete Relation',
        emptyTable: 'No user in the selected country is an HR Business Partner.',
        notifications: {
          delete: {
            success: {
              title: 'Success',
              description: 'Role HR Business Partner successfully deleted on {{employeeFirstName}} for {{companyName}}.',
            },
            error: {
              title: 'Error while deleting HR Business Partner relation',
              description: 'An error occurred while deleting the relation. Please, try again.',
            },
          },
        },
      },
      deletionModal: {
        heading: 'Delete HR Business Partner',
        description:
          'Are you sure you want to remove <0>{{employeeName}}</0> from the role of HR Business Partner of the company <0>{{companyName}}</0>?',
        deletionError: 'An error occurred while deleting the HR Business Partner role.',
      },
      infoBox: {
        counterHeading: 'HR Business Partners',
        filterHeading: 'Create new HR Business Partner Relation',
        selectCompanies: 'Select Companies',
        companies: 'Companies',
        employee: 'Employee',
        notFoundSearchSelectContent: 'Please type in some longer name or name matching failed...',
        selectEmployee: 'Select Employee',
        add: 'Add HR Business Partner',
        creationError: 'An error occurred while creating a new HR Business Partner relation.',
        notifications: {
          success: {
            title: 'Success',
            description: '{{employeeFirstName}} successfully set as HR Business Partner.',
          },
          error: {
            title: 'Error while setting HR Business Partner',
            description: 'An error occurred while setting HR Business Partner. Please, try again.',
          },
        },
      },
    },
    countrySettingsTab: {
      heading: 'Country Settings',
      guidelines: 'Country Settings Guidelines',
      cutoffDay: {
        heading: 'Cutoff Day',
        modal: {
          editCutoffDay: 'Edit Cutoff Day',
          cutoffDayCurrentValueLabel: 'Current Cutoff Day',
          cutoffDayNewValueLabel: 'New Cutoff Day',
          cutoffDayErrorMessage: 'An error occurred while updating the cutoff day.',
          cutoffDayPlaceholder: 'Select cutoff day.',
        },
        cutoffDayDescription:
          '<0>Cutoff Day</0> is used to determine whether the current month can be included in appraisal payments. Its value can range from 1 to 31. If the appraisal date falls on or before the specified cutoff day, the current month is included in the three-month appraisal payment window. If the appraisal date falls after the cutoff day, the current month is excluded. The special value 0 can be used to always exclude the current month.',
      },
      notifications: {
        success: {
          title: 'Success',
          description: 'Cutoff day successfully updated.',
        },
      },
    },
    nationalContractReferenceTab: {
      heading: 'NC-Level Minimum Salaries',
      filterByType: 'Filter by NC Type',
      table: {
        columns: {
          level: 'Level',
          minSalary: 'Minimum salary',
        },
      },
      editModal: {
        heading: 'Edit NC-Level Minimum Salaries',
        subheading: '{{contractType}}',
        emptyInputHint: 'Leave a field empty to keep the current minimum salary for that level.',
        newValuePlaceholder: 'New value',
        errorMessage: 'An error occurred while updating the minimum salaries. Please try again.',
        saveDisabledTooltip: 'Enter at least one new minimum salary to save your changes.',
        columns: {
          level: 'Level',
          currentMinSalary: 'Current min. salary',
          newMinSalary: 'New min. salary',
        },
        notifications: {
          success: {
            title: 'Success',
            description: 'Minimum salaries successfully updated.',
          },
        },
      },
      importModal: {
        heading: 'Import minimum salaries',
        topDisclaimer: 'Select a National Contract Type to enable file upload. You can use this import to update minimum salaries in bulk.',
        uploadBeforeText:
          'If you need a template for the selected type, <0>download it here</0>. Upload the completed file below. Fill in only the New min. salary column and leave a cell empty to keep the current value. Do not modify the Level or Current min. salary columns.',
        scopeLabel: 'Import scope',
        scopePlaceholder: 'Select a National Contract Type',
        allTypes: 'All National Contract Types',
        confirmButton: 'Confirm',
        confirmDisabledTooltips: {
          noScope: 'Select an import scope to continue.',
          noFile: 'Upload a file to import.',
          validationError: 'Fix the errors in the file and upload it again.',
        },
        formatMessage: 'Only .xlsx files up to 1 MB are supported.',
        processingMessage: 'Processing file...',
        successMessage: 'File validated successfully. Click Confirm to apply your changes.',
        templateFilenameAll: 'NC-Level Minimum Salaries - all types - template',
        templateFilenameSingle: 'NC-Level Minimum Salaries - {{contractType}} - template',
        notifications: {
          success: {
            title: 'Success',
            description: 'Minimum salaries successfully imported.',
          },
        },
        errors: {
          message1: 'The file could not be imported.',
          message2: 'Please fix the issues and upload the file again.',
          unknown: 'An unexpected error occurred while importing the file. Please try again.',
          emptyFile: 'The uploaded file does not contain any sheets.',
          emptySheet: 'The sheet for {{contractType}} does not contain any data rows.',
          scopeMismatchSingle: 'The uploaded file must contain exactly one sheet matching the selected contract type.',
          scopeMismatchAll:
            'The uploaded file must contain exactly {{expectedCount}} sheets, one for each contract type. Found {{actualCount}} sheets.',
          extraSheet: 'Unexpected sheet "{{sheetName}}". Remove extra sheets or select the matching import scope.',
          missingSheet: 'Missing sheet for contract type {{contractType}}.',
          missingLevelColumn: 'The sheet for {{contractType}} is missing the Level column.',
          missingNewSalaryColumn: 'The sheet for {{contractType}} is missing the New min. salary column.',
          unknownLevel: 'Unknown level "{{level}}" in {{contractType}} at row {{rowNo}}.',
          missingLevel: 'Missing level "{{level}}" in the sheet for {{contractType}}.',
          duplicateLevel: 'Duplicate level "{{level}}" in the sheet for {{contractType}}.',
          invalidMinSalary: 'Invalid New min. salary value in {{contractType}} at row {{rowNo}}. Values must be greater than 0.',
          noChanges: 'At least one minimum salary must be changed before importing.',
        },
      },
    },
    noCompanyId: 'There are no companies assigned to you.',
    noBusinessUnit: 'There are no business units assigned to you.',
    empty: {
      heading: 'You currently have no companies with active employees',
      message: 'As soon as active employees are present, it will be possible to see company overview.',
    },
  },
}
